import { useQuery } from 'react-query'
import { fetchExpertMentors } from '../apis/api.assignation'

export const queryKeyHRExpertMentors = ['Expert Mentors', 'Status']

export const useHRExpertMentors = () => {
    const { data, ...rest } = useQuery({
        queryKey: queryKeyHRExpertMentors,
        queryFn: fetchExpertMentors,
        staleTime: 1000 * 60 * 3, // 3 minutes
    })

    return { ...data, ...rest }
}
